import type { Move } from '../../../schemas/move';

/**
 * Archetipi dello Sciamano (manuale V1, rr. 5504-5512).
 *
 * 5 mosse di tipo `class_special`. Pattern razza-tematico standard come per
 * le altre 8 classi razza-tematiche già trascritte.
 *
 * **Archetipo Elfo**: l'effetto «quando prendi *Amico degli Spiriti* o *Figlio
 * degli Spiriti* puoi scegliere anche tra le mosse del Mago» è un'estensione
 * runtime sul pool di scelta multiclasse di quelle 2 mosse. Cross-archetipo
 * description-only, coerente con il pattern Ranger archetipo Umano (riferimento
 * cross-archetipo a *Ramingo* e *Grampasso*).
 */

const archetipoUmano: Move = {
  id: 'sciamano.archetipo-umano',
  name: 'Archetipo: Umano',
  type: 'class_special',
  classId: 'sciamano',
  trigger: "Quando usi una presa di *Aiuto dall'Altro Mondo* contro una creatura",
  description:
    "Puoi usarne una in più e infliggere al bersaglio 1d6 danni (solo 1d6, senza altri bonus), oltre all'effetto di base.",
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoElfo: Move = {
  id: 'sciamano.archetipo-elfo',
  name: 'Archetipo: Elfo',
  type: 'class_special',
  classId: 'sciamano',
  trigger: 'Quando *prendi *Amico degli Spiriti* o *Figlio degli Spiriti**',
  description:
    'Puoi scegliere anche tra le mosse del Mago.\n\n**NB**: questo archetipo estende il pool di scelta multiclasse delle mosse *Amico degli Spiriti* (L2-5) e *Figlio degli Spiriti* (L6-10), che di base permettono di scegliere dal Barbaro o dal Druido. Riferimento cross-archetipo description-only.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoNano: Move = {
  id: 'sciamano.archetipo-nano',
  name: 'Archetipo: Nano',
  type: 'class_special',
  classId: 'sciamano',
  trigger: 'Quando sei sottoterra',
  description:
    'Nessuno spirito attaccherà te o chi è sotto la tua protezione, a meno che non venga attaccato per primo.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoHalfling: Move = {
  id: 'sciamano.archetipo-halfling',
  name: 'Archetipo: Halfling',
  type: 'class_special',
  classId: 'sciamano',
  trigger: 'Quando evochi il fantasma di un antenato per assisterti',
  description: 'Raggiungi sempre la persona giusta.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoMezzorco: Move = {
  id: 'sciamano.archetipo-mezzorco',
  name: "Archetipo: Mezz'orco",
  type: 'class_special',
  classId: 'sciamano',
  trigger: 'Quando una delle tue mosse richiede di prendere danno',
  description:
    'Puoi mangiare il cuore di una creatura appena uccisa e ridurre di 2 il danno subito.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

export const sciamanoArchetypeMoves: readonly Move[] = [
  archetipoUmano,
  archetipoElfo,
  archetipoNano,
  archetipoHalfling,
  archetipoMezzorco,
] as const;
